// React
import React, { Fragment } from "react";
import PropTypes from "prop-types";

function ManageApprovalFooter({
  onCloseHandler,
  isEditApprovalMode,
  isSubmitBtnDisabled = false,
  isLoading = false,
}) {
  const cancelButton = (
    <button
      type="button"
      className="btn-secondary"
      data-dismiss="modal"
      onClick={() => onCloseHandler()}
    >
      Cancel
    </button>
  );

  const updateButtons = isEditApprovalMode && (
    <Fragment>
      <button
        className="btn-primary"
        onClick={() => onCloseHandler(true, false)}
        disabled={isSubmitBtnDisabled || isLoading}
      >
        Update Pending
      </button>
      <button
        className="btn-primary"
        onClick={() => onCloseHandler(true, true)}
        disabled={isSubmitBtnDisabled || isLoading}
      >
        Update All
      </button>
    </Fragment>
  );

  const createButton = !isEditApprovalMode && (
    <button
      type="submit"
      className="btn-primary"
      disabled={isSubmitBtnDisabled || isLoading}
      onClick={() => onCloseHandler(true)}
    >
      Create
    </button>
  );

  return (
    <Fragment>
      {cancelButton}
      {updateButtons || createButton}
    </Fragment>
  );
}

ManageApprovalFooter.propTypes = {
  onCloseHandler: PropTypes.func.isRequired,
  isEditApprovalMode: PropTypes.bool.isRequired,
  isSubmitBtnDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default ManageApprovalFooter;
